module.exports = function($, gsap, ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);


    let isDesktop = false;

    if( $(window).width() > 991 ){
        isDesktop = true;
    }

    if( isDesktop == true ){


        if( $('.section.page-head .the-title').length > 0 ){
            let tl = gsap.timeline({});
            let t2 = gsap.timeline({});
            tl.from('.section.page-head .the-title span:nth-child(1)', { "translateX": "-50%", "opacity": 0 } ).to(".section.page-head .the-title span:nth-child(1)", {  "opacity": 1 } );
            t2.from('.section.page-head .the-title span:nth-child(2)', { "translateX": "50%", "opacity": 0 } ).to(".section.page-head .the-title span:nth-child(2)", {  "opacity": 1 } );
        }

        if( $('.section.company-values').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.company-values",
                    start: "top bottom",
                    end: "+=500",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.company-values",
                    start: "top bottom",
                    end: "+=500",
                    scrub: 1,

                },
            });
            let t3 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.company-values",
                    start: "top bottom",
                    end: "+=600",
                    scrub: 1,

                },
            });
            t1.from(".section.company-values .the-title span:nth-child(1)", {
                // scrollTrigger: ".section.company-values",
                x: -100,
            });
            t2.from(".section.company-values .the-title span:nth-child(2)", {
                // scrollTrigger: ".section.company-values",
                x: 100,
            });

            for(  let i=1; i<= 3; i++  ){
                if( $(".section.company-values .area-right ul li:nth-child("+i+")").length > 0 ){
                    t3.from(".section.company-values .area-right ul li:nth-child("+i+")", {
                        x: 100,
                        opacity: 0
                    });
                }
            }


        }

        if(  $('.section.masthead').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.masthead",
                    start: "bottom bottom",
                    end: "+=200",
                    scrub: 1,
                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.masthead",
                    start: "bottom bottom",
                    end: "+=200",
                    scrub: 1,
                },
            });
            t1.to(".section.masthead .col-lg-6:nth-child(1)", {
                x: -50,
            });
            t2.to(".section.masthead .col-lg-6:nth-child(2)", {
                x: 50,
            });
        }

        if(  $('.section.wallpaper-text').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.wallpaper-text",
                    start: "top bottom",
                    end: "+=600",
                    scrub: 1,
                },
            });

            t1.from(".section.wallpaper-text .content", {
                x: 100
            });

        }

        if(  $('.section.masthead').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.masthead .area-bottom",
                    start: "bottom bottom",
                    end: "+=200",
                    scrub: 1,
                },
            });

            t1.to(".section.masthead .area-bottom .logos", {
                x: -50,
            });
        }


        if(  $('.section.quote').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.quote",
                    start: "top bottom",
                    end: "+=500",
                    scrub: 1,
                },
            });

            t1.from(".section.quote .the-title ", {
                y: 400,
            });

        }


        if( $('.section.labels-grid').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.labels-grid",
                    start: "top bottom",
                    end: "+=900",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.labels-grid",
                    start: "top bottom",
                    end: "+=900",
                    scrub: 1,

                },
            });
            t1.from(".section.labels-grid .the-title span:nth-child(1)", {
                x: -300,
            });
            t2.from(".section.labels-grid .the-title span:nth-child(2)", {
                x: 300,
            });
        }

        if( $('.section.text-layout1').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout1",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout1",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            t1.from(".section.text-layout1 .the-title span:nth-child(1)", {
                x: -300,
                opacity: 0
            });
            t2.from(".section.text-layout1 .the-title span:nth-child(2)", {
                x: 300,
                opacity: 0
            });
        }
        if( $('.section.text-layout2').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout2",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout2",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            t1.from(".section.text-layout2 .the-title span:nth-child(1)", {
                x: -50,
                opacity: 0
            });
            t2.from(".section.text-layout2 .the-title span:nth-child(2)", {
                x: 50,
                opacity: 0
            });
        }
        if( $('.section.text-layout3').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout3",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.text-layout3",
                    start: "top bottom",
                    end: "+=400",
                    scrub: 1,

                },
            });
            t1.from(".section.text-layout3 .the-title span:nth-child(1)", {
                x: -100,
                opacity: 0
            });
            t2.from(".section.text-layout3 .the-title span:nth-child(2)", {
                x: 100,
                opacity: 0
            });
        }

        if( $('.section.chart').length > 0 ){
            let t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.chart",
                    start: "top bottom",
                    end: "+=500",
                    scrub: 1,

                },
            });
            let t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section.chart",
                    start: "top bottom",
                    end: "+=500",
                    scrub: 1,

                },
            });

            t1.from(".section.chart .the-title span:nth-child(1)", {
                // scrollTrigger: ".section.company-values",
                x: -100,
            });
            t2.from(".section.chart .the-title span:nth-child(2)", {
                // scrollTrigger: ".section.company-values",
                x: 100,
            });

        }
    }
}
